import { gql } from "@apollo/client";
import { ROADMAP_FRAGMENT } from "pages/Round/roadmapQuery";

export const COMPLETE_TASK = gql`
  ${ROADMAP_FRAGMENT}

  mutation CompleteTask($code: String!, $taskId: ID!) {
    completeTask(code: $code, taskId: $taskId) {
      code
      success
      message
      roadmap {
        ...RoadmapFragment
      }
      completed_task {
        id
        category
        is_completed
        completed_at
      }
      sms_sent_count
    }
  }
`;

export const makeCompleteTaskOptions = (roadmapCode, taskId) => ({
  variables: {
    code: roadmapCode,
    taskId,
  },
});
